export enum ActivationRunStageEnum {
  INGESTION = 'INGESTION',
  TRANSFORMATION = 'TRANSFORMATION',
  LOADING = 'LOADING'
}
